
  import createMeisterIcons from '../src/createMeisterIcons';

  const Card = createMeisterIcons("card", [["path",{"fill":"currentColor","d":"M3.75 7c0-.686.564-1.25 1.25-1.25h14c.686 0 1.25.564 1.25 1.25v2.25H3.75zm0 3.75V17c0 .71.489 1.25 1.25 1.25h14c.686 0 1.25-.564 1.25-1.25v-6.25zM5 4.25A2.756 2.756 0 0 0 2.25 7v10c0 1.49 1.111 2.75 2.75 2.75h14A2.756 2.756 0 0 0 21.75 17V7A2.756 2.756 0 0 0 19 4.25z","key":"a7ce8b2fa16b940323177f4a1b23ecab924395ac","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Card
  